import { Tfa } from './tfa';
import { TfaService } from './tfa.service';

export function resolveTfaList(tfaService: TfaService): Promise<Tfa[]> {
  return new Promise((resolve) => {
    tfaService.getList().subscribe(resolve);
  });
}
